import { useLocaleStore } from "@/lib/i18n/useLocale";
import {
  AG_GRID_LOCALE_DE,
  AG_GRID_LOCALE_EN,
  AG_GRID_LOCALE_ES,
  AG_GRID_LOCALE_FR,
  AG_GRID_LOCALE_IT,
  AG_GRID_LOCALE_JP,
  AG_GRID_LOCALE_CN,
  AG_GRID_LOCALE_PT,
} from "@ag-grid-community/locale";

export function useAgGridLocalization() {
  const locale = useLocaleStore((state) => state.locale);

  switch (locale) {
    case "en":
      return AG_GRID_LOCALE_EN;
    case "es":
      return AG_GRID_LOCALE_ES;
    case "pt":
      return AG_GRID_LOCALE_PT;
    case "fr":
      return AG_GRID_LOCALE_FR;
    case "de":
      return AG_GRID_LOCALE_DE;
    case "it":
      return AG_GRID_LOCALE_IT;
    case "ja":
      return AG_GRID_LOCALE_JP;
    case "zh":
      return AG_GRID_LOCALE_CN;
  }
}
